module.exports = __webpack_public_path__ + "img/pen.0d6be1b6.svg";